import * as types from "./gameUserLogin.constant";

const defaultState = {
language:"en" , direction:"ltr",
    formData: {
        phoneNo:"",
        userName:"",
        otp: "",
        },
    remainingTime: 0,
    iv: null,
};

export default function (state = defaultState, action = {}) {
    switch (action.type) {
        case types.GAME_USER_LOGIN_ACTION_PERSIST:
            return {
                ...state,
                ...action.payload,
            };
        case types.GAME_USER_LOGIN_ACTION_CLEAR:
            return defaultState;
        default:
            return state;
    }
}
